import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { NewDanceModalProps } from "../interfaces/Timeline";
import { useState } from "react";

export default function NewDanceModal(props: NewDanceModalProps) {

  const [validated, setValidated] = useState<boolean>(false);

  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);

    if (props.newDanceName.length > 0) {
      props.addNewDance(props.newDanceName, props.newBarNumber, props.newBeatsPerBarNumber); 
      props.setShowNewDanceModal(false);
    }
  };

  return (
    <Modal show={props.showNewDanceModal} onHide={()=>props.setShowNewDanceModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Add a new dance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>New dance name</Form.Label>
          <Form.Control
            required
            value={props.newDanceName}
            onChange={(e) => props.setNewDanceName(e.target.value)}
            placeholder="Name of first dance"
          />
          <Form.Control.Feedback type="invalid">
            Please choose a name for the new dance.
          </Form.Control.Feedback>
        </Form.Group>


        <Form.Group className="mb-3" as={Row}>
          <Form.Label>Bars in new dance</Form.Label>
          <Col xs="11">
            <Form.Range
              value={props.newBarNumber}
              onChange={(e) => props.setNewBarNumber(+e.target.value)}
              min={1}
              max={24}
              step={1}
            />
          </Col>
          <Col xs="1">
            <Form.Label>{props.newBarNumber}</Form.Label>
          </Col>
        </Form.Group>

        <Form.Group className="mb-3" as={Row}>
          <Form.Label>Bars in new dance</Form.Label>
          <Col xs="11">
            <Form.Range
              value={props.newBeatsPerBarNumber}
              onChange={(e) => props.setNewBeatsPerBarNumber(+e.target.value)}
              min={2}
              max={16}
              step={2}
            />
          </Col>
          <Col xs="1">
            <Form.Label>{props.newBeatsPerBarNumber}</Form.Label>
          </Col>
        </Form.Group>
      </Form>
        

      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
